import { Permission } from '@cims-online/shared'
import { simpleRemoveNotification } from 'hooks/notificationHandler'
import { useRemoveDocumentChecklistItemMutation } from 'schema'
import { DefaultMutationHookOptions } from 'utils/defaults'
import { RemoveRowActionOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/row'
import {
  DocumentChecklistItem,
  useDocumentChecklistsTableContext,
} from '../../../../DocumentChecklistsTableContext'

export function useRemoveOptions(): RemoveRowActionOptions<DocumentChecklistItem> {
  const { refetch } = useDocumentChecklistsTableContext()
  const [removeItem] = useRemoveDocumentChecklistItemMutation({
    ...DefaultMutationHookOptions,
    onCompleted: ({
      removeDocumentChecklistItem: {
        documentChecklistItem: { name },
      },
    }) => simpleRemoveNotification(name),
  })
  return {
    hard: true,
    disabled: ({ documentChecklistValues }) =>
      documentChecklistValues.some(({ checked }) => checked)
        ? {
            message:
              'Document Checklist Items cannot be deleted if they have been marked on one or more Concrete Test Sets',
          }
        : false,
    permission: Permission.RemoveDocumentChecklistItem,
    onRemove: async ({ id }) => {
      await removeItem({ variables: { id } })
      refetch()
    },
  }
}
